import { Autocomplete } from "@apptus/esales-api";
import { useMarket } from "@context/marketContext";
import getAutocomplete from "@server/requests/elevate/getAutocomplete";
import type { UseQueryResult } from "@tanstack/react-query";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

const useAutocomplete = ({
  query,
  enabled = true,
}: {
  query: string;
  enabled?: boolean;
}): UseQueryResult<Autocomplete, Error> => {
  const { market } = useMarket().state;

  const response = useQuery({
    queryKey: ["autocomplete", market.code, query],
    queryFn: () =>
      getAutocomplete(market, {
        q: query,
      }),
    placeholderData: keepPreviousData,
    enabled,
  });

  return response;
};

export default useAutocomplete;
